import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { AuthConsumer } from '../../contexts/Auth';
import { Translate, LanguageList } from '../../contexts/Language';

class Header extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.toggleLanguage = this.toggleLanguage.bind(this);
        this.toggleprofile = this.toggleprofile.bind(this);

        this.state = {
            dropdownOpen: false,
            dropdownOpenLanguage: false,
            dropdownOpenprofile: false,
            user: {}
        };
    }
    componentDidMount() {


        this.setState({
            user: JSON.parse(localStorage.getItem('user'))
        });

    }
    toggle() {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }
    toggleLanguage() {
        this.setState(prevState => ({
            dropdownOpenLanguage: !prevState.dropdownOpenLanguage
        }));
    }
    toggleprofile() {
        this.setState(prevState => ({
            dropdownOpenprofile: !prevState.dropdownOpenprofile
        }));
    }
    togglescreen(e) {
        if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement) {  // current working methods
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
            }
        } else {
            if (document.cancelFullScreen) {
                document.cancelFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            }
        }
    }

    render() {
        return (
            <AuthConsumer>
                {({ onLogout }) => (
                    <div className="topbar">
                        <div className="topbar-left">
                            <Link to="/" className="logo">
                            <span className="logo-wrapper">
                                            <img src="/assets/images/logo/logo-light.svg" alt="" height="17" />
                                            <span className="logo-subtitle">PERSONNEL PANEL</span>
                                        </span>
                                <i>
                                    <img src="/assets/images/logo/logo-icon-light.svg" alt="" height="22" />
                                </i>
                            </Link>
                        </div>
                        <nav className="navbar-custom">
                            <ul className="navbar-right d-flex list-inline float-right mb-0">
                                <li className="dropdown notification-list d-none d-md-block">
                                    <LanguageList />
                                </li>
                                <li className="dropdown notification-list d-none d-md-block">
                                    <Link onClick={() => this.togglescreen()} className="nav-link waves-effect" to="#" id="btn-fullscreen">
                                        <i className="mdi mdi-fullscreen noti-icon"></i>
                                    </Link>
                                </li>
                                <li className="dropdown notification-list">
                                    <div className="dropdown notification-list nav-pro-img">
                                        <Dropdown isOpen={this.state.dropdownOpenprofile} toggle={this.toggleprofile}>
                                            <DropdownToggle className="dropdown-toggle testflag nav-link arrow-none waves-effect nav-user" tag="a">
                                                <img src="/assets/images/users/user-none.png" alt="user" className="rounded-circle" /> &nbsp; {this.state.user.fullName}  &nbsp;<span className="mdi mdi-chevron-down"></span>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem><Link to="/profile" className="d-block"><i className="mdi mdi-account-circle m-r-5"></i>Profile</Link></DropdownItem>
                                                <DropdownItem><Link to="/settings" className="d-block"><i className="mdi mdi-settings m-r-5"></i>{Translate('Settings')}</Link></DropdownItem>
                                                <DropdownItem onClick={(e) => onLogout(e)}><i className="mdi mdi-power text-danger m-r-5"></i>Logout</DropdownItem>
                                            </DropdownMenu>
                                        </Dropdown>
                                    </div>
                                </li>
                            </ul>
                            <ul className="list-inline menu-left mb-0">
                                <li className="float-left">
                                    <button className="button-menu-mobile open-left waves-effect">
                                        <i className="mdi mdi-menu"></i>
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                )}
            </AuthConsumer>

        );
    }
}

export default Header;